import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

export function LoadingBlock({ rows = 5, className }) {
  return (
    <div className={`space-y-3 ${className}`}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-12 bg-[#1A1A1A] rounded-lg animate-pulse" style={{ animationDelay: `${i * 60}ms` }} />
      ))}
    </div>
  );
}

export function EmptyState({ title = 'No results found', description, action, actionLabel }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-12 h-12 rounded-full bg-[#1A1A1A] border border-[#2A2A2A] flex items-center justify-center mb-4">
        <span className="text-[#D4A843] text-xl font-['EB_Garamond']">?</span>
      </div>
      <p className="text-[#F2F2F2] font-medium mb-1">{title}</p>
      {description && <p className="text-[#B9B9B9] text-sm max-w-xs">{description}</p>}
      {action && (
        <Button onClick={action} className="mt-4 btn-gold" size="sm">{actionLabel || 'Take action'}</Button>
      )}
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-12 h-12 rounded-full bg-[#2A1414] border border-[#4A1F1F] flex items-center justify-center mb-4">
        <AlertCircle size={20} className="text-[#FFD7D7]" />
      </div>
      <p className="text-[#F2F2F2] font-medium mb-1">Something went wrong</p>
      <p className="text-[#B9B9B9] text-sm max-w-xs mb-4">{message || 'An error occurred. Please try again.'}</p>
      {onRetry && (
        <Button onClick={onRetry} variant="outline" size="sm" className="gap-2">
          <RefreshCw size={13} /> Try again
        </Button>
      )}
    </div>
  );
}
